<template>
    <div :class="{'d-inline-block': btnInline}">
        <button class="btn uppercase"
            :class="{
                'w-72': !btnInline,
                'w-full h-full': gridLayout,
                'line-height-normal': btnLineHeight,
                'btn-primary--brand btn-record': btnPrimary
            }"
            v-if="!isRecording"
            @click="toggleRecorder"
            ><slot name="StartBtnLabel">Stimme aufnehmen</slot></button>
        <button class="btn uppercase"
            :class="{
                'btn-primary--brand w-72': btnPrimary,
                'w-full h-full': gridLayout,
                'line-height-normal': btnLineHeight
            }"
            v-if="isRecording"
            :disabled="isCountdown || initUserMedia"
            @click="stopRecorder"
            @mousedown="stopRecorder"
        >{{showTime ? `Aufnahme stoppen: ${recordedTime} sek` : 'Aufnahme stoppen'}}</button>
    </div>

</template>

<script>
import Recorder from './lib/recorder.js';
import { mapFields } from 'vuex-map-fields';
import { convertTimeMMSS }  from './lib/utils.js';

export default {
    props: {
        attempts        : { type: Number },
        time            : { type: Number },
        showTime        : false,
        btnPrimary      : false,
        btnInline       : false,
        btnLineHeight   : false,
        gridLayout      : false,

        bitRate    : { type: Number, default: 128   },
        sampleRate : { type: Number, default: 48000 },
        format     : { type: String, default: 'mp3' },

        micFailed        : { type: Function },
        beforeRecording  : { type: Function },
        pauseRecording   : { type: Function },
        afterRecording   : { type: Function },
        failedUpload     : { type: Function },
        beforeUpload     : { type: Function },
        successfulUpload : { type: Function },
        selectRecord     : { type: Function }
    },
    data () {
        return {
            isUploading   : false,
            recorder      : null,
            recordList    : [],
            uploadStatus  : null,
        }
    },

    computed: {
        isPause() {
            return this.recorder && this.recorder.isPause
        },

        initUserMedia() {
            return this.recorder && this.recorder.initUserMedia
        },

        recordedTime() {
            if (this.recorder) {
                if (this.time && this.recorder.duration >= this.time) {
                    this.stopRecorder()
                }

                return this.initUserMedia ? 'vorb.' : (this.recorder ? convertTimeMMSS(this.recorder.duration) : '0')
            }

            return 0;
        },

        recordingVolume() {
            if (this.recorder) {
                return this.recorder.currentVolume;
            }

            return 0;
        },

        ...mapFields({
            maxRecordings: 'theme.maxRecordings',
            soundFiles: 'soundFiles',
            isRecording: 'isRecording',
            isCountdown: 'isCountdown',
            recordingDuration: 'recordingDuration'
        })
    },
    watch: {
        // update global state too
        isRecording(newValue) {
            // set the recordingDuration to 0 when stopped
            if(!newValue) {
                this.$store.commit('updateField', {
                    path: 'recordingDuration',
                    value: '0'
                });
            }
        },

        initUserMedia(newValue) {
            this.$store.commit('updateField', {
                path: 'initUserMedia',
                value: newValue
            });
        },

        recordedTime(newValue) {
            if (this.recorder) {
                this.$store.commit('updateField', {
                    path: 'recordingDuration',
                    value: newValue
                });

                this.isCountdown = this.recorder.duration < 0;
            } else {
                this.isCountdown = false
            }
        },

        recordingVolume(newValue) {
            this.$store.commit('updateField', {
                path: 'recordingVolume',
                value: newValue
            });
        }
    },
    mounted () {
        // init: read uploaded files from store into local recordList
        if(this.$store.state.soundFiles) {
            this.recordList = this.$store.state.soundFiles;
        }

        // allow starting and stopping recorder from other parts of the app through events
        this.$root.$on('startRecorder', () => {
            this.startRecorder();
        });
        this.$root.$on('stopRecorder', () => {
            this.stopRecorder();
        });
    },
    beforeDestroy () {
        this.stopRecorder()
    },
    methods: {
        toggleRecorder () {
            if (this.attempts && this.recorder.records.length >= this.attempts) {
                return
            }

            if (!this.isRecording) {
                this.startRecorder()
            } else {
                this.stopRecorder()
            }
        },

        startRecorder() {
            this.recorder = this._initRecorder();
            if (this.isRecording) {
                return;
            }

            this.recorder.start();
            this.isRecording = true;
            this.isCountdown = true;
        },

        stopRecorder () {
            if (!this.isRecording) {
                return;
            }

            this.recorder.stop();
            this.isRecording = false;
            this.isCountdown = false;
            this.initUserMedia = false;
            this.recorder = null;
        },

        _initRecorder () {
            return new Recorder({
                beforeRecording : this.beforeRecording,
                afterRecording  : this.afterRecording,
                pauseRecording  : this.pauseRecording,
                micFailed       : this.micFailed,
                bitRate         : this.bitRate,
                sampleRate      : this.sampleRate,
                format          : this.format
            })
        },
    }
}
</script>


